import { Button, Collapse } from "@mui/material";
import { navbarHeight } from "./navbar";
import { ExpandMore } from "./card";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import LoadingBarApp from "./loading";

export function CustomDividerVertical({ color, width, extraMargin, verticalMargin="0px" }) {
    return <div style={{backgroundColor: color, width: width, margin:`${verticalMargin} ${extraMargin}`}}></div>;
}

export function CustomDividerHorizontal({ color, height, extraMargin, horizontalMargin="0px" }) {
    return <div style={{backgroundColor: color, height:height, margin:`${extraMargin} ${horizontalMargin}`}}></div>;
}

export function RoundButton({ text, onClick=()=>{}, endIcon, startIcon, disabled }) {
    return <Button variant="outlined" style={{borderRadius: 90, borderWidth:'2px', width:'-webkit-fill-available'}} color="primary" endIcon={endIcon} onClick={onClick} disabled={disabled}>{text}</Button>
}

export function NavbarHeight({}) {
    return <div style={{height: navbarHeight}}></div>;
}

export function ExpandableArea({ children, expanded, setExpanded, title, margin}) {
    return <div>
        <ExpandMore
            expand={expanded}
            onClick={() => {setExpanded(!expanded)}}
            aria-expanded={expanded}
            aria-label="show more"
            title={title}
        >
            <ExpandMoreIcon/>
        </ExpandMore>
        <Collapse in={expanded} timeout="auto" unmountOnExit sx={{margin: margin? '0px 10%' : null}}>
            {children}
        </Collapse>
    </div>
}

export function Margin({ width, height }) {
    return <div style={{width: width, height: height}}/>;
}

export function LoadingPage() {
    return <div style={{height: 'calc(100vh - 140px)'}}>
        <LoadingBarApp/>
    </div>
}

export function PageTitle({ children }) {
    return <h1 style={{color: 'var(--h2-color)', margin: 0}}>{children}</h1>;
}

export function PageSubtitle({ children }) {
    return <h2 style={{color: 'var(--h2-color)', margin: 0}}>{children}</h2>;
}